module.exports = __webpack_public_path__ + "img/n49.694c09f4.svg";